import { z } from 'zod';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { City, CitySchema } from '@/types/city/city.type.ts';

export type CitiesPaginator = {
    data: City[],
    meta: PaginationMeta,
};

export type CitiesRequestFilter = {
    page?: number,
    name?: string,
    created_at?: [string, string],
    sort?: Record<string, string>[],
};

export const CitiesSchema = z.array(CitySchema);

export const CitiesPaginatorSchema = z.object({
    data: CitiesSchema,
    meta: PaginationMetaSchema,
});
